import { Empty } from "../../components/Empty.js";

/**
 * 充值记录占位页（2026-07 拍板：等 W3 核销数据模型定型后补，先留导航位）。
 */
export function RechargePanel(): JSX.Element {
  return (
    <Empty
      title="充值记录即将上线"
      description="上线后可查看本组织的充值与核销明细"
    />
  );
}
